module.exports = __webpack_public_path__ + "media/images/icons/outlined/insert-row-left-20481daa40556a57fc40ff30f330e98d.svg";